import React, {memo} from "react";
import {VideoTypes} from "./BallroomPage";
import {makeStyles} from "@material-ui/core/styles";
import NavButton from "./NavButton";

const useStyles = makeStyles({
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '1.1vw'
    }
})

const NavButtons = ({videoType}) => {

    const classes = useStyles()

    return (<div className={classes.buttons} >
        <NavButton label={'Welcome Address'} curVideoType={videoType} buttonVideoType={VideoTypes.WELCOME}/>
        <NavButton label={'Panel Discussion'} curVideoType={videoType} buttonVideoType={VideoTypes.PANEL} />
        <NavButton label={'Award Presentation'} curVideoType={videoType} buttonVideoType={VideoTypes.AWARD}/>
    </div>);
}

export default memo(NavButtons)